module.exports = __webpack_public_path__ + "static/media/logitech.8d5f6ca5.png";